import * as React from "react";

export type HeadingProps = {
  kind: 'h2' | 'h3'
  title: string
  extraClasses: string
}

export const HeadingLayout = (p: HeadingProps) => {
  return p.kind === 'h2' ? (
    <h2 className={p.extraClasses} dangerouslySetInnerHTML={{ __html: p.title}} />
  ) : (
    <h3 className={p.extraClasses} dangerouslySetInnerHTML={{ __html: p.title}} />
  )
}
